module.exports = __webpack_public_path__ + "img/icon_3.83e70dc3.png";